import { TranslationOutlined } from '@ant-design/icons';
import React from 'react';

export const openGoogleTranslate = ({
  text = '',
  from = 'auto',
  to = 'en',
  width = 800,
  height = 600,
}) => {
  const url = `https://translate.google.com/#${from}/${to}/${encodeURI(text)}`;
  window.open(url, 'googletranslate', `width=${width},height=${height}`);
};

export default function TranslationButton({
  ...args
}) {
  return (
    <TranslationOutlined
      title="Translate"
      onClick={() => {
        openGoogleTranslate(args);
      }}
    />
  );
}
